import { Token } from "@bentolabs/points-worker";
import { useQuery } from "@tanstack/react-query";
import invariant from "tiny-invariant";
import { useChainId, usePublicClient } from "wagmi";

import { tokensMeta } from "shared/config/tokens";

export type PointToken = Token & {
  decimals: number;
  logoURI?: string;
};

export const usePointsTokensQuery = () => {
  const pc = usePublicClient();
  const chainId = useChainId();

  return useQuery({
    queryKey: ["points", "tokens"],
    queryFn: async () => {
      invariant(pc, "pc is undefined");
      const response = await fetch("/points/tokens");
      const tokens: Token[] = await response.json();
      const result: PointToken[] = tokens.map((t) => {
        const meta = tokensMeta[t.symbol];
        return { decimals: 6, ...t, ...meta, chainId };
      });

      return result;
    },
  });
};
